export enum BankAccountInputLabel {
  AccountHolder = 'Name of the account holder',
  BankName = 'Bank Name',
  RoutingNumber = 'Routing Number',
  AccountNumber = 'Account Number',
}
